<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">タリフ（サプライヤー別）検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          @click="search"
          class="btn-search"
          :disabled="!valid"
          small
          v-permit.SHARP_CHARGE_SEARCH
          >{{ $t('app.buttons.search') }}</v-btn
        >
        <v-menu
          offset-y
          style="margin-right: 20px; margin-left: 20px"
          v-if="true"
        >
          <v-btn slot="activator" small v-permit.SHARP_CHARGE_NEW>
            新規
            <v-icon right>keyboard_arrow_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              :key="index"
              @click="toNew(item, index)"
              v-for="(item, index) in newMenu"
            >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-btn
          :disabled="selected.length !== 1"
          @click="edit"
          small
          v-permit.SHARP_CHARGE_EDIT.SHARP_CHARGE_DETAIL
          >{{ $t('app.buttons.edit') }}</v-btn
        >
        <v-btn
          :disabled="selected.length === 0"
          @click="remove"
          small
          v-permit.SHARP_CHARGE_DELETE
          >{{ $t('app.buttons.remove') }}</v-btn
        >

        <v-btn @click="exportCsv" small v-permit.SHARP_CHARGE_DOWNLOAD>{{
          $t('app.buttons.csvExport')
        }}</v-btn>

        <v-menu
          offset-y
          style="margin-right: 20px; margin-left: 20px"
          v-if="true"
        >
          <v-btn slot="activator" small v-permit.SHARP_CHARGE_NEW>
            アップロード
            <v-icon right>keyboard_arrow_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile>
              <v-btn @click="upload" flat>海運（freight THC LSS CIC） </v-btn>
              <input
                @change="fileChanged"
                ref="file"
                style="display: none"
                type="file"
                id="excel-upload"
              />
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>
        <a
          @click="$downloadTemplate('Pricing', 'excel')"
          href="#"
          v-permit.SHARP_CHARGE_NEW
          >excel template</a
        >
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-select
                :clearable="true"
                :items="newMenu"
                @change="query.chargeItemId = null"
                item-text="title"
                item-value="type"
                label="费用名"
                v-model="query.type"
              />
            </v-flex>
            <v-flex key="SEA" md3 sm6 v-if="query.type === 'SEA'" xs12>
              <remote-select
                :filter="
                  (p) =>
                    query.type === 'SEA' &&
                    p.isSea &&
                    p.isFreight &&
                    p.isFreightNeedConfigPricing
                "
                item-text="name"
                item-value="id"
                label="費用項目"
                url="charge-items/kv?projection=full"
                v-model="query.chargeItemId"
              />
            </v-flex>
            <v-flex key="AIR" md3 sm6 v-if="query.type === 'AIR'" xs12>
              <remote-select
                :filter="
                  (p) =>
                    query.type === 'AIR' &&
                    p.isAir &&
                    p.isFreight &&
                    p.isFreightNeedConfigPricing
                "
                item-text="name"
                item-value="id"
                label="費用項目"
                url="charge-items/kv?projection=full"
                v-model="query.chargeItemId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="サプライヤー"
                url="companies/kv"
                v-model="query.supplierId"
              />
            </v-flex>

            <v-flex md6 sm6 xs6>
              <v-layout row wrap>
                <v-flex md2 pr-2>
                  <v-select
                    :items="locationTypes"
                    label="区分名"
                    v-model="query.departureType"
                  />
                </v-flex>
                <v-flex
                  key="departurePortCode"
                  md10
                  pl-2
                  v-if="query.departureType === 'PORT'"
                >
                  <remote-autocomplete
                    label="発地"
                    url="ports/kv"
                    v-model="query.departurePortCode"
                  />
                </v-flex>
                <v-flex
                  key="departureWarehouseId"
                  md10
                  pl-2
                  v-if="query.departureType === 'WAREHOUSE'"
                >
                  <remote-autocomplete
                    label="発地"
                    url="warehouses/kv"
                    v-model="query.departureWarehouseId"
                  />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md6 sm6 xs6>
              <v-layout row wrap>
                <v-flex md2>
                  <v-select
                    :items="locationTypes"
                    label="区分名"
                    v-model="query.destinationType"
                  />
                </v-flex>
                <v-flex
                  key="destinationPortCode"
                  md10
                  pl-2
                  v-if="query.destinationType === 'PORT'"
                >
                  <remote-autocomplete
                    label="着地"
                    url="ports/kv"
                    v-model="query.destinationPortCode"
                  />
                </v-flex>

                <v-flex
                  key="destinationWarehouseId"
                  md10
                  pl-2
                  v-if="query.destinationType === 'WAREHOUSE'"
                >
                  <remote-autocomplete
                    label="着地"
                    url="warehouses/kv"
                    v-model="query.destinationWarehouseId"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input
                    label="適用開始日"
                    v-model="query.startDateFrom"
                  ></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input v-model="query.startDateTo"></date-input>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input
                    label="適用終了日"
                    v-model="query.endDateFrom"
                  ></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input v-model="query.endDateTo"></date-input>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-card-title>
        <h3>タリフ（サプライヤー別）</h3>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-1"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td width="40">
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.supplierCode }} - {{ props.item.supplierName }}</td>
          <td>{{ props.item.transportModeName }}</td>
          <td>{{ props.item.commodityTypeName }}</td>
          <td>
            {{ props.item.specialName || props.item.deliverySpecialName }}
          </td>
          <td>{{ pricingTypeName(props.item) }}</td>
          <td>
            {{ props.item.chargeItemName }} {{ props.item.containerTypeCode }}
          </td>
          <td>{{ props.item.chargeUnitName }}</td>
          <td>{{ props.item.departure }}</td>
          <td>{{ props.item.destination }}</td>
          <td>
            <span style="padding-right: 10px">{{
              props.item.currencyName
            }}</span>
            <span>{{ props.item.requestPrice }}</span>
          </td>
          <td>
            <span style="padding-right: 10px">{{
              props.item.currencyName
            }}</span>
            <span>{{ props.item.showPaymentPrice }}</span>
          </td>
          <td>{{ props.item.startDate }}</td>
          <td>{{ props.item.endDate }}</td>
          <td>{{ props.item.updatedDate }}</td>
          <td>{{ props.item.updatedBy }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
    type() {
      if (this.type == '納入場所') {
        this.query.portCode = null
      }
      if (this.type == '港') {
        this.query.warehouseId = null
      }
    },
  },
  data: () => ({
    valid: false,
    type: '港',
    query: {
      departureType: 'PORT',
      destinationType: 'PORT',
    },
    loading: false,
    results: [],
    pagination: {
      rowsPerPage: 10,
    },
    locationTypes: [
      { value: 'PORT', text: '港' },
      { value: 'WAREHOUSE', text: '纳入场所' },
    ],
    selected: [],
    showHeaders: [
      { text: 'サプライヤー', value: 'supplierCode' },
      { text: '運送形態', value: 'transportModeName' },
      { text: '商品種類', value: 'commodityTypeName' },
      { text: 'SPECIAL', value: 'specialName' },
      { text: 'チャージ名称', value: 'pricingTypeName' },
      { text: 'チャージ项目', value: 'chargeItemName' },
      { text: '課金単位', value: 'chargeUnitName' },
      { text: '発地港', value: 'departurePortName', sortable: false },
      { text: '着地港', value: 'destinationPortName', sortable: false },
      { text: '着地', value: 'destinationWarehouseName', sortable: false },
      { text: '通貨', value: 'currencyName' },
      { text: '請求単価', value: 'requestPrice' },
      { text: '支払単価', value: 'showPaymentPrice' },
      { text: '適用開始日', value: 'startDate' },
      { text: '適用終了日', value: 'endDate' },
      { text: '更新日付', value: 'updatedDate' },
      { text: '更新メンバー', value: 'updatedBy' },
    ],
    headers: [
      { text: 'サプライヤー', value: 'supplierCode' },
      { text: '運送形態', value: 'transportModeName' },
      { text: '商品種類', value: 'commodityTypeName' },
      { text: 'SPECIAL', value: 'specialName' },
      { text: 'チャージ名称', value: 'pricingTypeName' },
      { text: 'チャージ项目', value: 'chargeItemName' },

      { text: '課金単位', value: 'chargeUnitName' },
      { text: '発地', value: 'departure', sortable: false },
      { text: '着地', value: 'destination', sortable: false },
      { text: '請求単価', value: 'requestPrice' },
      { text: '支払単価', value: 'paymentPrice' },
      { text: '適用開始日', value: 'startDate' },
      { text: '適用終了日', value: 'endDate' },
      { text: '更新日付', value: 'meta.updateAt' },
      { text: '更新メンバー', value: 'meta.updateBy' },
    ],
    newMenu: [
      { title: '海運', type: 'SEA' },
      { title: '空運', type: 'AIR' },
      { title: '通関料', type: 'CUSTOMS_CLEARANCE' },
      { title: '搬出手数料', type: 'CARRYING' },
      { title: '取扱料', type: 'HANDING' },
      { title: 'CC.FEE', type: 'CC_FEE' },
      { title: 'デバン料', type: 'DEVAN' },
      { title: 'ドレージ', type: 'DRAKE' },
      { title: 'チャーター', type: 'CHARTER' },
      { title: '混載', type: 'MIX_LOADING' },
      { title: 'destination charge', type: 'DESTINATION_CHARGE' },
      { title: 'Import Handing Charge', type: 'IMPORT_HANDING_CHARGE' },
      { title: 'SJL Handing Charge', type: 'SJL_HANDING_CHARGE' },
    ],
  }),
  methods: {
    upload() {
      // this.$download(`/pricings/excel-upload`);
      this.$refs.file.click()
    },
    fileChanged(e) {
      if (e.target.files.length === 0) return
      let file = e.target.files[0]
      let formData = new FormData()
      formData.append('file', file)
      return this.$http
        .post(`/pricings/excel-upload`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          responseType: 'blob',
        })
        .then((res) => {
          const contentType = res.headers['content-type'];
          if (contentType.includes('application/json')) {
            const reader = new FileReader();
            reader.onload = () => {
              const jsonResponse = JSON.parse(reader.result);
              if(jsonResponse.success){
                this.$message(
                  this.$t('app.messages.success.title'),
                  `読み込み完了いたしました。`
                )
              }
            };
            reader.readAsText(res.data);
            this.excelUploadClear()
            return
          }
          this.$parseResponseExcel(res)
          this.excelUploadClear()
        })
        .catch((err) => {
          this.excelUploadClear()
          new Response(err.response.data).json().then((res) => {
            if (res.message == 'EXCEL_TEMPLATE_NOT_RIGHT') {
              this.$message(
                this.$t('app.messages.errors.title'),
                `不正なテンプレート`
              )
            } else {
              this.$message(
                this.$t('app.messages.errors.title'),
                `system error`
              )
            }
          })
        })
    },

    excelUploadClear() {
      let excelUpload = document.getElementById('excel-upload')
      excelUpload.value = ''
    },

    toNew(item, index) {
      this.$router.push({ path: `/M0130/new/${index + 1}`, query: item })
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.selected = []
      this.$http.get('/pricings', this.params()).then((res) => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content.map((d) => ({
          ...d,
          departure: `${d.departurePortName || d.departureWarehouseName || ''}`,
          destination: `${d.destinationPortName ||
            d.destinationWarehouseName ||
            ''}`,
        }))
        this.loading = false
        this.selected = []
      })
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    edit() {
      let index = this.newMenu
        .map((m) => m.type)
        .indexOf(this.selected[0].pricingTypeCode)
      this.$router.push({
        path: `/M0130/edit/${index + 1}`,
        query: { id: this.selected[0].id },
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map((s) => {
              return this.$http.delete(`/pricings/${s.id}`)
            })
          ).then(() => {
            this.load()
            this.selected = []
          })
        }
      )
    },
    pricingTypeName(item) {
      let menu = this.newMenu.filter((i) => i.type == item.pricingTypeName)
      if (menu.length > 0) return menu[0].title
    },
    exportCsv() {
      let params = {
        ...this.query,
        ...this.$pageable(),
        page: 0,
        size: 9999999,
      }
      this.$http.get('/pricings', { params: params }).then((res) => {
        if (res.data.content.length > 0) {
          // let headers = headers.text
          // let showHeaders = headers.value
          // let headers = Object.keys(res.data.content[0])
          // let showHeaders = Object.keys(res.data.content[0])
          res.data.content.forEach((r) => {
            r.chargeItemName = r.chargeItemName + r.containerTypeCode
            r.specialName = r.specialName || r.deliverySpecialName
          })

          this.$exportTable(
            res.data.content,
            this.showHeaders.map((p) => p.value),
            this.showHeaders.map((p) => p.text),
            'price'
          )
        }
      })
    },
  },
  mounted() {
    this.$loadParams()
    //this.load()
  },
}
</script>
